import { RegistrationStatus, RegistrationType } from '@la/types';
const isRegisteredToProgram = (registration, programId, userId) => {
    return (registration.programId === programId &&
        registration.registrationStatus === RegistrationStatus.Registered &&
        registration.registeredUserId === userId &&
        !registration.deleted);
};
const isRegisteredToTeam = (registration, programId, userId, teamIdOg) => {
    return (isRegisteredToProgram(registration, programId, userId) &&
        registration.teamIdOg === teamIdOg);
};
/**
 * Determine if the user is the team primary staff for the team.
 * @param userRegistrations Registrations of the user
 * @param programId
 * @param userId
 * @param teamId OG team id
 */
export const isTeamPrimaryStaff = (userRegistrations, programId, userId, teamId) => {
    const existingRegistration = userRegistrations.find((registration) => {
        return (registration.registrationType === RegistrationType.Team &&
            isRegisteredToTeam(registration, programId, userId, teamId));
    });
    return !!existingRegistration;
};
// Determines if user is registered as free agent staff or team staff for the program/team
export const isExistingStaff = (userRegistrations, programId, userId, teamId) => {
    const existingRegistration = userRegistrations.find((registration) => {
        let matchingType = false;
        if (teamId) {
            matchingType =
                (registration.registrationType === RegistrationType.Staff ||
                    registration.registrationType === RegistrationType.Team) &&
                    teamId === registration.teamIdOg;
        }
        else {
            matchingType =
                registration.registrationType === RegistrationType.StaffFreeAgent;
        }
        return (matchingType && isRegisteredToProgram(registration, programId, userId));
    });
    return !!existingRegistration;
};
